export type Question = {
  question: string;
  description: string;
};

// SINGLE DOCUMENT QUESTIONS

const generalDocumentQuestions: Question[] = [
  { question: "Summarize this document", description: "" },
];

const protocolDocumentQuestions: Question[] = [
  { question: "Summarize this document", description: "" },
  { question: "What were the eligibility criteria?", description: "" },
  { question: "What databases were searched?", description: "" },
  { question: "What gray literature sources were searched?", description: "" },
  { question: "What time period do the searches cover?", description: "" },
  { question: "What study quality assessment framework was used?", description: "" }, 
];

const publicationDocumentQuestions: Question[] = [
  { question: "Summarize this publication", description: "" },
];

const reportDocumentQuestions: Question[] = [
  { question: "Provide a comprehensive summary of this report", description: "" },
  { question: "Provide a plain language summary of this report with key takeaway messages", description: "" },
  { question: "What were the eligibility criteria?", description: "" },
  { question: "What databases were searched?", description: "" },
  { question: "What gray literature sources were searched?", description: "" },
  { question: "What time period do the searches cover?", description: "" },
  { question: "What study quality assessment framework was used?", description: "" },
  { question: "How many studies were included?", description: "" },
  { question: "Give me a list of the included studies", description: "" },
];

// MULTI DOCUMENT QUESTIONS

const generalDocumentsQuestions: Question[] = [
  { question: "Summarize these documents", description: "" },
];

const protocolDocumentsQuestions: Question[] = [
  { question: "Summarize these documents", description: "" },
];

const publicationDocumentsQuestions: Question[] = [
  { question: "Summarize these publications", description: "" },
];

const reportDocumentsQuestions: Question[] = [
  { question: "Summarize these documents", description: "" },
];

// PROJECT QUESTIONS

const projectQuestions: Question[] = [
  { question: "Summarize this project", description: "" },
  { question: "How many studies were included?", description: "" },
  { question: "Give me a list of the included studies", description: "" },
  { question: "What is the scope of studies included?", description: "" },
];

// MULTIPLE PROJECT QUESTIONS

const projectsQuestions: Question[] = [
  { question: "Summarize these projects", description: "Get a brief overview of the projects' content" },
  { question: "What is the scope of studies included?", description: "Summarize various aspects" },
];

// NO QUESTIONS

const emptyQuestions: Question[] = [];

export function deriveCommonQuestions(projects: any[] | undefined, documents: any[] | undefined): Question[] {
  const numDocs = Array.isArray(documents) ? documents.length : 0;
  const numProjects = Array.isArray(projects) ? projects.length : 0;

  // MULTIPLE PROJECT QUESTIONS
  if (numProjects > 1) {
    return projectsQuestions;
  }

  // PROJECT QUESTIONS
  if (numProjects === 1) {
    return projectQuestions;
  }

  // Need to determine if all the documents are of the same stage and which specific stage
  const documentStages = Array.isArray(documents) ? documents.map(doc => doc.stage) : [];
  const uniqueDocumentStages = [...new Set(documentStages)];
  const uniqueStage = uniqueDocumentStages.length === 1 && uniqueDocumentStages[0]
    ? uniqueDocumentStages[0].toLowerCase().replace(/ /g, "_")
    : "";

  // MULTIPLE DOCUMENT QUESTIONS
  if (documents && numDocs > 1) {
    if (uniqueStage === "protocol") {
      return protocolDocumentsQuestions;
    } else if (uniqueStage === "screening") {
      return emptyQuestions;
    } else if (uniqueStage === "included_publications") {
      return publicationDocumentsQuestions;
    } else if (uniqueStage === "data_extraction") {
      return emptyQuestions;
    } else if (uniqueStage === "report") {
      return reportDocumentsQuestions;
    } else {
      return generalDocumentsQuestions;
    }
  }

  // SINGLE DOCUMENT QUESTIONS
  if (documents && numDocs === 1) {
    if (uniqueStage === "protocol") {
      return protocolDocumentQuestions;
    } else if (uniqueStage === "screening") {
      return emptyQuestions;
    } else if (uniqueStage === "included_publications") {
      return publicationDocumentQuestions;
    } else if (uniqueStage === "data_extraction") {
      return emptyQuestions;
    } else if (uniqueStage === "report") {
      return reportDocumentQuestions;
    } else {
      return generalDocumentQuestions;
    }
  }

  return emptyQuestions;
}
